import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cursor",
  "use": "icon-cursor-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-cursor\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<polygon points=\"12.57 12.39 14.55 17.84 12.74 18.5 10.76 13.05 8.08 15.07 9.04 5.5 15.92 12.22 12.57 12.39\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol